import { IMAGES } from "../../common/constants";
import "../PWAInstallHandler/installation-popup.scss";

interface InstallPWADialogProps {
  installPWA: () => void;
  closeDialog: () => void;
}

const InstallPWADialog = ({
  installPWA,
  closeDialog,
}: InstallPWADialogProps) => {
  return (
    <div className="installationPopupWrapper">
      <figure className="brandLogo">
        <img src={IMAGES.Logo} alt="logo" />
      </figure>
      <h1 className="popupHeading">Add Databis to Your Home Screen</h1>

      <p className="popupParagraph">
        Enjoy a better experience by adding Databis to your device's home screen
        for quick, easy access.
      </p>
      <div>
        <div className="btnWrap">
          <button
            type="button"
            onClick={installPWA}
            className="MuiButton-contained"
          >
            Add to Home Screen
          </button>
          <button
            type="button"
            onClick={closeDialog}
            className="MuiButton-outlined "
          >
            Skip for Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPWADialog;
